import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login, error, setError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) navigate("/app/dashboard");
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-[#fafaf8]">
      <div className="hidden md:flex flex-col justify-between p-12 bg-[#0a0a0a] text-[#fafaf8] relative overflow-hidden">
        <Link to="/" className="flex items-center gap-2" data-testid="login-brand-link">
          <span className="block w-2 h-2 bg-[#d95d39]" />
          <span className="font-['Outfit'] text-xl font-bold">FinCanvas</span>
        </Link>
        <div>
          <p className="tc-overline mb-4" style={{ color: "#d95d39" }}>Welcome back</p>
          <h2 className="font-['Outfit'] text-5xl font-bold tracking-tight leading-[0.95]">
            Your studio is
            <br />still in business.
          </h2>
          <p className="mt-6 text-[#a3a39b] max-w-md">
            Pick up where you left off — pending collections are waiting, and so is your AI co-pilot.
          </p>
        </div>
        <div className="text-xs text-[#5a5a53]">© 2026 FinCanvas · Made in India</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <p className="tc-overline mb-3">Sign in</p>
          <h1 className="font-['Outfit'] text-3xl font-bold tracking-tight mb-8">Open your canvas</h1>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs tracking-[0.18em] uppercase font-bold text-[#5a5a53]">Email</Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-11 rounded-md border-[#e5e5e0] focus-visible:ring-[#d95d39]"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs tracking-[0.18em] uppercase font-bold text-[#5a5a53]">Password</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 h-11 rounded-md border-[#e5e5e0] focus-visible:ring-[#d95d39]"
                required
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-xs text-[#b83a26] bg-[#fff4f1] border border-[#f5d5cb] px-3 py-2 rounded-md">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={submitting}
              data-testid="login-submit"
              className="w-full h-11 bg-[#0a0a0a] hover:bg-[#1a1a1a] text-white rounded-md"
            >
              {submitting ? "Signing in..." : "Sign in"}
            </Button>
          </form>

          <p className="mt-8 text-sm text-[#5a5a53]">
            New here?{" "}
            <Link to="/register" data-testid="goto-register" className="text-[#d95d39] hover:underline font-medium">
              Create an account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
